export default __webpack_public_path__ + "static/ARTE-5-fea6ed0c6347dee5abc36b55336c210d.jpg";